/** @format */

// Phrases sourced from https://github.com/i1kazantsev/claude-code-spinner (MIT)

export const SPINNER_PHRASES: readonly string[] = [
  'Обкашляю вопросик',
  '10/10',
  'Метнулся',
  'Решаю вопросик',
  'Сейчас подскочу',
  'За кофейчком метнусь',
  'Шуршу в соцсетях',
  'Услышал тебя',
  'Всё чин-чинарём',
  'Он человечек хороший',
  'Кофейные вопросики обкашляем',
  'Всё, я поскакал',
  'Пошуршу по трендам',
  'Метнулся за трендами',
  'Обкашляем новиночки',
  'Пойдём по сигареточке',
  'Вопросик на контроле',
  'Цифры знаешь — набирай',
  'Дорогой мой человечек',
  'Человечек подскочит',
  'Наберу на цифры',
  'Водочки с нами выпьешь?',
  'Обрисуй персонажей',
  'На подскоке',
  'Дельце одно есть',
  'Человечек сориентирует',
  'Двигаюсь в сторону центра',
  'С центра уже двинул',
  'Вопросик этот вентилируй',
  'Добро',
  'Обнял-целую',
  'Словимся',
  'Тема мутная',
  'Чёт не функционирует',
  'Я на офисе',
  'Обрисуй ситуацию',
  'Когда обед?',
  'Человечек денюшку передаст',
  'В выходной с двяками на шишлядос!',
  'А ты парень смекалистый',
  'Зарядил на точку человечка',
  'Абонент не абонент',
  'Я на моторе',
  'Раньше всё по-другому было',
  'Уже трём за этот вопросик',
  'Человечка нашего подхвати',
  'Здарова, бандит',
  'Цифры свои скинь',
  'Фактурочку откройте',
  'По незнанке сунулся',
  'С тебя поляна',
  'Не мороси',
  'За него человечки потянут',
  'Человечка пускать?',
  'По красоте всё сделаем',
  'ЭС как русская С',
  'Речь идёт о трёхзначных цифрах',
  'Поставил дело на карандаш',
  'Тоси-боси',
  'Надо тему покачать',
  'П*издос-бандос',
  'Евроденс',
  'Когда получка?',
  'Всё в ажуре',
  'Главного позовите',
  'Не отсвечивай',
  'Отскочим — побормочем',
  'Вопросик на тормозах',
  'Скидочка будет?',
  'Принял и понял',
  'Всё красиво, по предоплате',
  'Всё, бычкуюсь',
  'Всё на мази',
  'Движуха пошла',
  'Всё путём',
  'Порешаем',
  'Разрулим',
  'На созвоне',
  'Забились',
  'Без базара',
  'Тема рабочая',
  'Всё схвачено',
  'Подорвался',
  'Закинул удочку',
  'Буду через пятнашку',
  'Жду обратку',
  'Пробью по своим',
  'Братишка, не вопрос',
  'Контролирую процессик',
  'Тёрки какие-то пошли',
  'Тут такое дело',
  'На районе',
  'Занесу конвертик',
  'Схема рабочая',
  'Подкачу к вечерку',
  'Мониторю ситуацию',
  'Тема зашла',
  'Чаёк-кофеёк?',
  'Занятость полная',
] as const;
